import { Select } from "antd";
import { IOptions } from "../../../types/interfaces";
import { ICountry } from "country-state-city";

type Props = {
  handleSelectCountry: (value: string) => void;
  handleSearchCountry: (value: string) => void;
  countryOptions: IOptions[];
  country: ICountry | null;
};

function CountryFilter({
  handleSelectCountry,
  handleSearchCountry,
  countryOptions,
  country,
}: Props) {
  return (
    <Select
      value={country?.isoCode ? country.isoCode : ""}
      onChange={handleSelectCountry}
      options={countryOptions}
      onSearch={handleSearchCountry}
      showSearch
      filterOption={false}
      allowClear
      style={{ width: "200px" }}
    />
  );
}

export default CountryFilter;
